import PropTypes from "prop-types";
import { connect } from "react-redux";
import React, { useEffect, useState } from "react";
import ShopSearch from "../../components/product/ShopSearch";
import ShopCategories from "../../components/product/ShopCategories";
import {  setSearchTagKeys } from "../../pages/constant/Constants";
import { store } from "../..";
import { fetchTags } from "../../redux/actions/tagActions";

import ShopBrands from "../../components/product/ShopBrands";
import { Switch } from "antd";
import { useLocation } from "react-router-dom";
import { useHistory } from "react-router-dom";

import "./style.css";
import { fetchBrands } from "../../redux/actions/productActions";

const ShopSidebar = ({
  tagData,
  loading,
  getSortParams,
  setFilter,
  filters,
  getLayout,
  getFilterSortParams,
  // sideSpaceClass,
  categoryTreeData,
  setSidebarFilter,
  orientationClick,
  sortByClick,
  orientationButton,
  sortByButton,
  brandValue,
  formRef,
  brandsData,
  brandTotalCount,
  onDescriptionChange,
  setVisible,
  selectedBrands,
  setSelectedBrands,
  searchTag, 
  setSearchTag,
  scrollToTop, setScrollToTop
}) => {
  console.log("🚀 ~ brandsData:", brandsData)
  // Note: This is a temporary solution to exclude some categories from the sidebar
  const valuesToExclude = ["test category", "Mislenous", "DISCONTINUED"];
  const productSearchLocal = JSON.parse(localStorage.getItem("shop_search_filters") || '{}');
  const lowercasedValuesToExclude = valuesToExclude.map((value) =>
    value.toLowerCase()
  );
  const history = useHistory();
  const filteredCategory = categoryTreeData?.filter((item) => {
    const lowercasedItemName = item.name.toLowerCase();
    return lowercasedValuesToExclude.includes(lowercasedItemName);
  });
const dataList = [];

  const [expandedKeys, setExpandedKeys] = useState([]);
  const [searchValue, setSearchValue] = useState("");
  const [autoExpandParent, setAutoExpandParent] = useState();
  const [inputValue, setInputValue] = useState("");
  const [isSelected, setIsSelected] = useState(false);
  const [selectedMainCategory, setSelectedMainCategory] = useState("")
  const location = useLocation();
  const getQueryParam = (param) => {
    const queryParams = new URLSearchParams(location.search);
    return queryParams.get(param);
  };

  const getBrands = (searchTag) => {
    store.dispatch(fetchBrands({
      is_featured_brand: 1,
      page_size: -1,
      sort_by: "name:asc",
      category_ids: searchTag?.category_ids 
        ?? productSearchLocal?.search_filter?.category_ids 
        ?? ""
    }));
  };

useEffect(() => {
    getBrands(searchTag);
}, [searchTag?.category_ids, productSearchLocal?.search_filter?.category_ids]);

  const handleFilter = (value) => {
    setInputValue(value);
    setFilter((filter) => {
      return { ...filter, search_key: value };
    });
  };

  const handleKeyPress = (category) => {
    history.push(`/shop`);
    setSelectedMainCategory("")
    localStorage.setItem("parentCategory", "");
    setFilter((filter) => {
      return {
        ...filter,
        brand_ids: category?.id,
        category_ids: category?.id,
      };
    });
  };
  const handleSorting = (value) => {
    setFilter((filters) => {
        if (value === "1") {
            return {
                ...filters,
                sort_by: "",
                is_variant_group: "1",
            };
        } else {
            return {
                ...filters,
                sort_by: value,
                is_variant_group: "0",
            };
        }
    });
  }

const [filteredCategoryTree, setFilteredCategoryTree] = useState(categoryTreeData);
const [filteredBrand, setFilteredBrand] = useState(brandsData || []);

useEffect(() => {
  if (brandsData && brandsData.length > 0) {
    setFilteredBrand(brandsData);
  }
}, [brandsData]);

useEffect(() => {
  setFilteredCategoryTree(categoryTreeData);
}, [categoryTreeData]);

const handleSearch = (e, component) => {
  const { value } = e.target;
  const trimmedValue = value.trim();
  setSearchValue(trimmedValue);

  if (trimmedValue) {
    if (component === "category") {
      const matchedKeys = new Set();
      const searchTree = (nodes) => {
        return nodes
          .map((node) => {
            const isMatched =
              node.name && node.name.toLowerCase().includes(trimmedValue.toLowerCase());

            if (isMatched) {
              matchedKeys.add(node.id);
            }
            if (node.children) {
              const matchedChildren = searchTree(node.children);
              if (matchedChildren.length > 0) {
                matchedKeys.add(node.id);
                return { ...node, children: matchedChildren };
              }
            }
            return isMatched ? node : null;
          })
          .filter(Boolean);
      };

      const filteredCategories = searchTree(categoryTreeData);
      setFilteredCategoryTree(filteredCategories.length > 0 ? filteredCategories : []);
      setExpandedKeys([...matchedKeys]);
    }
    if (component === "brand") {
      const filteredBrands = brandsData.filter(
        (brand) => brand.name && brand.name.toLowerCase().includes(trimmedValue.toLowerCase())
      );
      setFilteredBrand(filteredBrands);
    }
    setAutoExpandParent(true);
  } else {
    if (component === "category") {
      setFilteredCategoryTree(categoryTreeData);
      setExpandedKeys([]);
    }

    if (component === "brand") {
      setFilteredBrand(brandsData);
    }

    setSearchValue("");
    setAutoExpandParent(false);
  }
};


  return (
    <div className="box">
      <div className="group">
        <div className="frame-3">
          <div className="display-mobile">
            <div className="text-wrapper-6">Sort By</div>
            <div style={{ marginTop: "10px" }}>
            <button
              className={`inactive-button ${sortByButton === "Low" ? "activeButton" : ""}`}
              onClick={() => {
                handleSorting("price:asc")
                sortByClick(sortByButton === "Low" ? "" : "Low");
            }}
            >
              Price - Low to High
            </button>

            <button
              className={`inactive-button ${sortByButton === "High" ? "activeButton" : ""}`}
              onClick={() => {
                handleSorting("price:desc")
                sortByClick(sortByButton === "High" ? "" : "High");
            }}
            >
              Price - High to Low
            </button> 
            <button
              className={`inactive-button ${sortByButton === "AtoZ" ? "activeButton" : ""}`}
              onClick={() => {
                  handleSorting("name:asc")
                  sortByClick(sortByButton === "AtoZ" ? "" : "AtoZ");
              }}
            >
             Name (A to Z)
            </button> 
            <button
              className={`inactive-button ${sortByButton === "ZtoA" ? "activeButton" : ""}`}
              onClick={() => {
                  handleSorting("name:desc")
                  sortByClick(sortByButton === "ZtoA" ? "" : "ZtoA");
              }}
            >
             Name (Z to A)
            </button> 
            </div>
          </div>
          <div className="scroller-class" style={{display:"flex", justifyContent:"space-between"}}>
          <div className="text-wrapper-filter">Filters</div>
            <div className="frame-10">
              <div className="frame-11">
                {/* <div className="text-wrapper-filter">Filters</div> */}
                <img
                  onClick={(e) => {
                    setSidebarFilter("inActive");
                  }}
                  src={`${process.env.PUBLIC_URL}/media/icons/black-left-line.png`}
                  alt="close"
                  style={{ cursor: "pointer" }}
                  className="responsive-filter"
                />
              </div>
            </div> 
          </div>
          <div >
            <div className="frame-10">
              <div className="frame-11" style={{ display: "flex", justifyContent: "space-between",marginBottom:"16px"}}>
                <div className="text-wrapper-6">Explore By Selection</div>
                {(filters?.is_hot_seller || filters?.is_featured || filters?.is_new_arrival) && (
                <div
                className="clear-filters-main red-hover"
                onClick={() => {
                  if (productSearchLocal.search_filter) {
                    productSearchLocal.search_filter.is_hot_seller = null;
                    productSearchLocal.search_filter.is_featured = null;
                    productSearchLocal.search_filter.is_new_arrival = null;
                    localStorage.setItem("shop_search_filters", JSON.stringify(productSearchLocal));
                  }
                  setFilter(prev => ({
                    ...prev,
                    is_featured: null,
                    is_hot_seller: null,
                    is_new_arrival: null,
                  }));
                  let currentSearchParams = new URLSearchParams(history.location.search);
                  currentSearchParams.delete("filter_other");
                  const newQueryString = currentSearchParams.toString();
                  const newPath = history.location.pathname;
                  history.push(`${newPath}${newQueryString ? `?${newQueryString}` : ''}`);
                }}
              >
               <span className="text-wrapper-6"> Clear</span>
              </div>
              
              )}
              </div>
              <ShopCategories
                setFilter={setFilter}
                filters={filters}
                formRef={formRef}
                loading={loading}
                filterKeyword={"OtherFilters"}
                setVisible={setVisible}
                setSidebarFilter={setSidebarFilter}
                scrollToTop = {scrollToTop}
                setScrollToTop = {setScrollToTop}
                brandsData={brandsData}
              />
              <div className="frame-13" style={{ display: "flex", justifyContent: "space-between",marginBottom:"16px"}}>
              <div className="text-wrapper-6">Categories</div>
              {(filters?.category_ids) && (
                <div
                  className="red-hover"
                  style={{ fontSize: "12px", cursor: "pointer", borderBottom: '1px solid #808080' }}
                  onClick={() => {
                    let currentSearchParams = new URLSearchParams(history.location.search);
                    currentSearchParams.delete("filter_brand");
                    localStorage.setItem("brandsPreserve", "");
                    setSearchTag((prev)=>({...prev,  category_ids:null,}))
                    if (productSearchLocal.search_filter) {
                      productSearchLocal.search_filter.category_ids = null;
                      productSearchLocal.search_filter.brand_ids = null;
                      localStorage.setItem("shop_search_filters", JSON.stringify(productSearchLocal));
                    }
                    localStorage.removeItem("brandsPreserve");
                    setSelectedBrands("");
                    setFilter((prev)=>({...prev,  category_ids:null,brand_ids: []}))
                    localStorage.setItem("parentCategory", "");
                    let currentPath = history.location.search ? history.location.search.substring(1).split("&") : [];
                    currentPath = currentPath.filter(segment => !segment.startsWith("filter_cat=") &&  !segment.startsWith("filter_brand="));
                    history.push(`/shop/?${currentPath.join("&")}`);
                    getBrands({category_ids:""})
                  }}
                >
                 <span className="text-wrapper-6">Clear</span>
                </div>
              )}
            </div>
            <div className="sidebar-search">
              <input
                type="text"
                className={`header-searchbar`}
                placeholder={"Search Categories"}
                onChange={(e) => {
                  setTimeout(() => handleSearch(e, "category"), 300);
                }}
                onKeyPress={(e) => {
                  if (e.key === "Enter") {
                    e.preventDefault();
                    return false;
                  }
                }}
              />
              <div className="search-icon" >
            <img
              src={`${process.env.PUBLIC_URL}/media/icons/Searchwhite.svg`}
              alt="Search"
              className="sidebar-search-icon"
            />
          </div>
              </div>
              
              <ShopCategories
                categories={filteredCategoryTree}
                getSortParams={getSortParams}
                setFilter={setFilter}
                filters={filters}
                formRef={formRef}
                loading={loading}
                filterKeyword={"Categories"}
                onDescriptionChange={onDescriptionChange}
                setVisible={setVisible}
                setSidebarFilter={setSidebarFilter}
                selectedMainCategory={selectedMainCategory}
                setSelectedMainCategory={setSelectedMainCategory}
                setSearchTag={setSearchTag}
                setSelectedBrands={setSelectedBrands}
                scrollToTop = {scrollToTop}
                setScrollToTop = {setScrollToTop}
              />
            </div>
            <div className="frame-13">
            <div className="frame-13" style={{ display: "flex", justifyContent: "space-between",marginBottom:"16px"}}>
              <div className="text-wrapper-6">Brand</div>
              {(localStorage.getItem("brandsPreserve")) && (
                <div
                className="red-hover"
                style={{ fontSize: "12px", cursor: "pointer", borderBottom: '1px solid #808080' }}
                onClick={() => {
                  try {
                    setScrollToTop(true);
                  } catch (err) {
                  }
                  if (productSearchLocal.search_filter) {
                    productSearchLocal.search_filter.brand_ids = null;
                    localStorage.setItem("shop_search_filters", JSON.stringify(productSearchLocal));
                  }
                  localStorage.setItem("brandsPreserve", "");
                  setSelectedBrands("");
                  setFilter(prev => ({
                    ...prev,
                    brand_ids: [],
                  }));
                  let currentSearchParams = new URLSearchParams(history.location.search);
                  currentSearchParams.delete("filter_brand");
                  const newQueryString = currentSearchParams.toString();
                  const newPath = history.location.pathname;
                  history.push(`${newPath}${newQueryString ? `?${newQueryString}` : ''}`);
                }}
              >
               <span className="text-wrapper-6">Clear</span>
              </div>
              
              )}
            </div>
            <div className="sidebar-search">
            <input
                type="text"
                className={`header-searchbar`}
                placeholder={"Search Brands"}
                onChange={(e) => {
                  setTimeout(() => handleSearch(e,"brand"), 300);
                }}
                onKeyPress={(e) => {
                  if (e.key === "Enter") {
                    e.preventDefault();
                    return false;
                  }
                }}
              />
            <div className="search-icon" >
            <img
              src={`${process.env.PUBLIC_URL}/media/icons/Searchwhite.svg`}
              alt="Search"
              className="sidebar-search-icon"
            />
          </div>
            </div>
            
              <ShopCategories
                categories={filteredBrand}
                getSortParams={getSortParams}
                setFilter={setFilter}
                filters={filters}
                formRef={formRef}
                loading={loading}
                filterKeyword={"Brands"}
                brandTotalCount={brandTotalCount}
                setVisible={setVisible}
                setSidebarFilter={setSidebarFilter}
                searchTag={searchTag}
                setSearchTag={setSearchTag}
                selectedBrands={selectedBrands}
                setSelectedBrands={setSelectedBrands}
                scrollToTop = {scrollToTop}
                setScrollToTop = {setScrollToTop}
              />
            </div>
          </div>
          {/* <div className="frame-19">
            <div className="frame-11">
              <div className="text-wrapper-6">Deals</div>
              <div className="switch-2">
                <Switch />
                <div className="text-wrapper-12">Select All</div>
              </div>
            </div>
          </div> */}
        </div>
      </div>
    </div>
  );
};

ShopSidebar.propTypes = {
  getSortParams: PropTypes.func,
  setFilter: PropTypes.func,
  products: PropTypes.array,
  categoryTreeData: PropTypes.array,
  sideSpaceClass: PropTypes.string,
  brandsData: PropTypes.array,
  brandTotalCount: PropTypes.string,
};

const mapStateToProps = (state) => {
  return {
    categoryTreeData: state.categoryData.entities,
    tagData: state.tagData.tags,
    settingData: state.settingData.ecom.basic,
    brandsData: state.brandsData.entities,
    brandTotalCount: state.brandsData.totalCount,
  };
};

export default connect(mapStateToProps)(ShopSidebar);
